import React, { Component } from 'react';
// import request from 'utils/request';
import { getCookie, delCookie, baiduStatistics, imageUrl } from 'utils';
// import { message } from 'antd';
// import $ from 'jquery';
import { PlatformStyle } from './platformComp';
import { Switch, Route, Redirect } from 'react-router-dom';
import Album from './album';
import Program from './program';
import Information from './information';

import { Menu } from 'antd';
const { SubMenu } = Menu;

export default class Platform extends Component {
    constructor(props) {
        super(props);

        this.state = {
            token: getCookie('token') ? JSON.parse(getCookie('token')) : '',
            path: '/platform/album'
        }
    }

    componentDidMount() {
        const { token } = this.state;
        const { push } = this.props.history;
        const { pathname } = this.props.location;
        // console.log(this.props.location.pathname);

        // 路由监听
        // listen(route => {
        //     console.log(route);

        //     if (route.pathname === '/platform/album') {
        //         this.setState({
        //             path: '/platform/album'
        //         });
        //     }
        // })

        if (pathname === '/platform') {
            this.setState({
                path: '/platform/album'
            });
        } else {
            this.setState({
                path: pathname
            });
        }


        if (!token) {
            push('/login');
        } else {
            baiduStatistics();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { pathname } = nextProps.location;

        if (pathname === '/platform') {
            this.setState({
                path: '/platform/album'
            });
        } else {
            this.setState({
                path: pathname
            });
        }

    }

    // 退出登录
    quit = () => {
        delCookie('token');

        window.location.reload();
    }


    handleClick = e => {
        // console.log('click ', e.key);
        const { push } = this.props.history;

        push(e.key);

        this.setState({
            path: e.key
        });
    };


    render() {
        const { token, path } = this.state;
        const { history: { push } } = this.props;

        return (<PlatformStyle>
            {token && <div className="platform-kfpt">
                <header className="platform-header">
                    <div className="wrapper">
                        <img onClick={() => push('/home')} className="platform-logo" src={require('images/platform/platform-logo.png')} alt="" />
                        <div className="platform-info">
                            <img className="icon" alt="" src={imageUrl(token.anchor_data.anchor_icon)} />
                            <div className="nickname">{token.anchor_data.anchor_name}</div>
                            <div className="quit" onClick={this.quit}>退出</div>
                        </div>
                    </div>
                </header>
                <div className="platform-main">
                    <div className="wrapper">
                        <Menu
                            onClick={this.handleClick}
                            style={{
                                width: 150,
                                maxHeight: 250,
                                borderRadius: 10,
                                // color: 'rgba(102,102,102,1)',
                                fontSize: 16
                            }}
                            // defaultSelectedKeys={[path]}
                            selectedKeys={path}
                            defaultOpenKeys={['sub1', 'sub2']}
                            mode="inline"
                        >

                            <SubMenu
                                key="sub1"
                                title={
                                    <span>
                                        <span style={{ fontWeight: 'bold' }}>节目</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="/platform/album">专辑管理</Menu.Item>
                                <Menu.Item key="/platform/program">节目管理</Menu.Item>
                            </SubMenu>
                            <SubMenu
                                key="sub2"
                                title={
                                    <span>
                                        <span style={{ fontWeight: 'bold' }}>资料设置</span>
                                    </span>
                                }
                            >
                                <Menu.Item key="/platform/information">账号设置</Menu.Item>
                            </SubMenu>
                        </Menu>

                        <div className="platform-item">
                            <Switch>
                                <Route exact path="/platform" component={Album} />
                                <Route exact path="/platform/" component={Album} />
                                <Route exact path="/platform/album" component={Album} />
                                <Route exact path="/platform/program" component={Program} />
                                <Route exact path="/platform/information" component={Information} />
                                <Redirect from="/platform/*" to="/platform/album" />
                            </Switch>
                        </div>

                    </div>
                </div>
            </div>}
        </PlatformStyle>);
    }
}